<mat-form-field [formGroup]="settings.form">
  <input matInput hidden [type]="settings.type" [formControlName]="settings.formControlName">
</mat-form-field>
